export default ({ components }) => () => components.optionsBar.numberOption('size');
